import React, { Component } from 'react';


class Header extends Component {
  render(){
    return(
      <header>
        <h1>raul gutierrez</h1>
      </header>
    )
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/Components/Header.js